/**
 * Ar App
 * This is a simple API for AR App
 *
 * OpenAPI spec version: 1.0.0
 * Contact: csong@lsq.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { FieldOption } from './fieldOption';
import { LabelFieldOptionLinks } from './labelFieldOptionLinks';

export interface LabelFieldOption extends FieldOption { 
    /**
     * Indicates the background color in several formats (english colors, hex, etc).
     */
    backgroundColor?: string;
    /**
     * Indicates the predefined start icon for the label.
     */
    startIcon?: LabelFieldOption.StartIconEnum;
    /**
     * Indicates if label should have a underline.
     */
    hasUnderline?: boolean;
    /**
     * Array of linked information
     */
    links?: Array<LabelFieldOptionLinks>;
}
export namespace LabelFieldOption {
    export type StartIconEnum = 'Account' | 'Password' | 'SMS';
    export const StartIconEnum = {
        Account: 'Account' as StartIconEnum,
        Password: 'Password' as StartIconEnum,
        SMS: 'SMS' as StartIconEnum
    };
}